export const testimonialsSwiper = () => ({
  initialized: false,
  init() {
    this.initialized = true;
  },
});
